import { gql } from '@apollo/client'

export const PlaybackFinished = gql`
    mutation PlaybackFinished($roomId: ID!, $requestId: ID!) {
        playbackFinished(roomId: $roomId, requestId: $requestId)
    }
`

export default PlaybackFinished
